var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_42728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 6.99992C11.2237 6.99992 10.9998 7.22377 10.9998 7.49992V12.4998C10.9998 12.776 10.776 12.9998 10.4998 12.9998H1.49998C1.22383 12.9998 0.999977 12.776 0.999977 12.4998V2.49998C0.999977 2.22383 1.22383 1.99998 1.49998 1.99998H7.4999C7.77605 1.99998 7.99991 1.77612 7.99991 1.49997C7.99991 1.22383 7.77605 1 7.4999 1H1.49998C0.671564 1 0 1.67156 0 2.49998V12.4998C0 13.3283 0.671564 13.9998 1.49998 13.9998H10.4999C11.3283 13.9998 11.9998 13.3283 11.9998 12.4998V7.49989C11.9998 7.22377 11.776 6.99992 11.4998 6.99992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4393 0.560684C13.0803 0.201626 12.5934 -5.06826e-05 12.0856 7.91038e-06C11.5776 -0.00145691 11.0902 0.200572 10.7322 0.561006L4.14624 7.14639C4.0916 7.20144 4.05038 7.26835 4.02574 7.34188L3.02576 10.3418C2.93849 10.6038 3.08014 10.887 3.34214 10.9742C3.39296 10.9911 3.4462 10.9998 3.49975 10.9998C3.55342 10.9998 3.60677 10.9911 3.65775 10.9744L6.65771 9.97438C6.73139 9.94977 6.79833 9.90834 6.8532 9.85338L13.4391 3.26747C14.1866 2.52006 14.1867 1.30818 13.4393 0.560684ZM12.7321 2.56096L6.23221 9.06088L4.29023 9.70936L4.93671 7.76987L11.4391 1.26998C11.7966 0.913209 12.3757 0.913795 12.7324 1.27127C12.9028 1.44204 12.9989 1.67322 12.9996 1.91447C13.0002 2.15702 12.9039 2.38975 12.7321 2.56096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_42728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6e1c637c2cb2b0b717b2d3ceb7f6887d.svg";
export { ForwardRef as ReactComponent };